import axios from './../http'

function query(data) {
    return axios.post('/sys/country/query', data);
}

function exportExcel(data){
    const url =  "/sys/country/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Country"+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function get(id) {
    return axios.get('/sys/country/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/country/add', data);
}

function update(data) {
    return axios.post('/sys/country/update', data);
}

function del(data) {
    return axios.post('/sys/country/del', data);
}

function valid(data) {
    return axios.post('/sys/country/valid', data);
}
function invalid(data) {
    return axios.post('/sys/country/invalid' , data);
}

function getOptions(status) {
    if(status == undefined){
        status="";
    }
    return axios.post('/sys/country/getOptions?status='+status);
}
export default {
    query,
    get,
    add,
    update,
    del,
    getOptions,
    valid,
    invalid,
    exportExcel
}